import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Inicial from "./pages/Inicial";
import Detalhes from "./pages/Detalhes";
import Menu from "./components/Menu";
import Pesquisado from "./components/Pesquisado/Pesquisado";
import RV from "./pages/RV";
import RA from "./pages/RA";
import Video360i from "./pages/V360i";
import Video360 from "./pages/V360"
import dados from "./data/projetosGerais.json";
import "./App.css";

function App() {
  const [resultados, setResultados] = useState([]);
  const location = useLocation(); // 👈 identifica a rota atual

  // Verifica se estamos na página de detalhes
  const estaEmDetalhes = location.pathname.startsWith("/projeto/");

  return (
    <>
      {/* Renderiza o Menu somente se NÃO estiver na página de detalhes */}
      {!estaEmDetalhes && <Menu dados={dados} aoPesquisar={setResultados} />}

      <Routes>
        <Route
          path="/"
          element={
            resultados.length > 0 ? (
              <Pesquisado
                resultados={resultados}
                limpar={() => setResultados([])}
              />
            ) : (
              <Inicial dados={dados} />
            )
          }
        />
        <Route path="/projeto/:id" element={<Detalhes />} />
        <Route path="/rv" element={<RV />} />
        <Route path="/ra" element={<RA />} />
        <Route path="/video360" element={<Video360 />} />
        <Route path="/video360i" element={<Video360i />} />
      </Routes>
    </>
  );
}

export default App;
